import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { DefaultPageEnum } from '../models/enums';
import { LoginComponentService } from '../services/system/login-component.service';
import { PermissionsService } from '../services';
import { SchedulerDefaultViewEnum } from '../models/enums/scheduler-default-view-enum';

@Injectable({ providedIn: 'root' })
export class RootPageRouteGuard  {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly loginComponentService: LoginComponentService,
    private readonly permSvc: PermissionsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;

    if (currentUser) {

      let url;

      switch (currentUser.defaultPage) {
        case DefaultPageEnum.Dashboard:
          url = '/dashboard';
          break;
        case DefaultPageEnum.Scheduler:
          url = '/scheduling/scheduler';
          break;
      }

      if (!url) {
        url = this.permSvc.checkEntityAccess("patients", "patients") ? '/patients' : '/user-settings';
      }

      this.router.navigate([url], { replaceUrl: true });
    }
    else {
      this.loginComponentService.navigateToLogin();
    }

    return false;
  }
}
